export enum DirectoryView {
  MINE = 1,
  LIST = 2,
  CONTACT_LIST = 3,
  ADDRESS_EDIT = 4,
  ADDRESS_DELETE = 5,
  CONTACT_EDIT = 6,
}
